import { AgGridReact } from 'ag-grid-react';
import React, { memo, useRef } from 'react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import './gridStyles.css';
import BtnComponent from '../buttonComponent/BtnComponent';

const ViewButtonCellRenderer = memo(function ViewButtonCellRenderer({
  data,
  onClick,
}) {
  const onClickHandler = event => {
    event.preventDefault();
    onClick(data);
  };

  return (
    <>
      <BtnComponent
        onClick={onClickHandler}
        title={'View details'}
        sx={{
          height: '20px',
          width: '100px',
          fontSize: '12px',
          fontWeight: '400',
        }}
      />
    </>
  );
});

const CustomAGgrid = ({ rowData, columnDefs, onItemView, coverage = false}) => {
  const gridRef = useRef();

  const DetailsRenderer = rowData => (
    <ViewButtonCellRenderer {...rowData} onClick={onItemView} />
  );

  const moreDetailsColumn = {
    field: '',
    cellRenderer: DetailsRenderer,
  };

  {!coverage && columnDefs.push(moreDetailsColumn)};

  const defaultColDef = {
    resizable: true,
  };

  return (
    <>
      <div
        id="MyGrid"
        className="ag-theme-material"
        style={{ height: '450px' }}>
        <AgGridReact
          defaultColDef={defaultColDef}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          suppressFieldDotNotation={true}
          enableBrowserTooltips={true}
          enableCellTextSelection
        />
      </div>
    </>
  );
};

export default CustomAGgrid;
